"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangeLabel = exports.FrequencyLabel = exports.DateLabel = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const media_1 = require("../../../../../utils/media");
const Typography_1 = require("../../../../atoms/Typography");
const DateLabel = (0, styled_components_1.default)(Typography_1.H5) `
  display: inline;
  font-weight: 600;
  text-transform: uppercase;

  @media ${media_1.media.desktop} {
    display: block;
    text-transform: none;
    font-weight: 400;
    font-size: 14px;
  }
`;
exports.DateLabel = DateLabel;
const FrequencyLabel = (0, styled_components_1.default)(Typography_1.H5) `
  display: inline;

  @media ${media_1.media.desktop} {
    display: block;
    font-size: 14px;
  }
`;
exports.FrequencyLabel = FrequencyLabel;
const RangeLabel = (0, styled_components_1.default)(Typography_1.H5) `
  display: inline;

  .hyphen-padding {
    padding: 0 8px;
  }

  @media ${media_1.media.desktop} {
    display: block;
    font-size: 14px;
  }
`;
exports.RangeLabel = RangeLabel;
